import { createIcon } from '@chakra-ui/react';

export default createIcon({
  displayName: 'GlobeStandIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    boxSize: 6,
  },
  path: (
    <g
      transform="translate(-14.68 -5.82) scale(0.034)"
      stroke="currentColor"
      strokeWidth="38.24"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <circle cx="780" cy="430" r="200" />
      <path d="M630 420A150 150 0 0 1 755 280" />
      <path d="M930 448A122 122 0 0 1 820 582" />
      <path d="M620 624Q780 660 940 624" />
      <path d="M620 624L575 760" />
      <path d="M940 624L985 760" />
      <path d="M560 760Q780 785 1000 760" />
      <path d="M520 792Q780 830 1040 792" />
      <path d="M520 792L1040 792" />
    </g>
  ),
});
